import { ApiPromotion } from '@api/interfaces';
import { getJsDateFromString } from '@shared/utilities';

export const getPromotionStatus = (promotion: Pick<ApiPromotion, 'endDate' | 'startDate'>) => {
  const currentTime = Date.now();

  const promoStartTime = getJsDateFromString(promotion.startDate,
    { timezone: 'PT' },
  ).getTime();

  const promoEndTime = getJsDateFromString(promotion.endDate,
    { endOfDay: true, timezone: 'PT' },
  ).getTime();

  if (currentTime < promoStartTime) {
    return PromotionStatus.FUTURE;
  }

  if (currentTime > promoEndTime) {
    return PromotionStatus.EXPIRED;
  }

  return PromotionStatus.RUNNING;
};

export enum PromotionStatus {
  FUTURE = 'future',
  RUNNING = 'running',
  EXPIRED = 'expired',
}
